<template>
  <div class="bg-putty lg:py-16 py-12">
    <div class="container sm:flex-row sm:space-x-8 flex flex-col px-0 mt-6">
      <div class="w-full lg:w-1/3">
        <div class="xl:flex-shrink-0 xl:pr-4 w-full sticky" style="top: 6rem">
          <h2 class="mr-auto fluid-4xl leading-none break-words" style="hyphens: auto">
            {{ heading }}
          </h2>
          <div class="text-copy mt-6 fluid-lg font-light leading-normal" v-html="underliner"></div>
          <h4 class="fluid-sm leading-tightest mt-4 font-medium">{{ linkListLabel }}</h4>
          <div class="flex flex-row flex-wrap mt-2 -mx-2">
            <nuxt-link
              v-for="{ uri, title } in linkList"
              :key="uri"
              :to="{ path: $localeRootPath(uri) }"
              class="btn-box btn-box-white hover:shadow-md fluid-sm leading-tightest mx-2 my-2 shadow-xl"
              >{{ title }}</nuxt-link
            >
          </div>
        </div>
      </div>

      <div class="lg:flex relative flex-wrap hidden lg:w-2/3 !ml-0">
        <div class="flex flex-row items-center justify-between w-full mx-10 my-4">
          <h3 class="mr-auto fluid-xl leading-tight font-medium">{{ routinesLabel }}</h3>
          <CtaArrow v-if="cta" v-bind="cta" class="mt-4 ml-auto" />
        </div>
        <div v-for="(routine, index) in routines" :key="routine.id" class="w-1/2 pl-10 pb-10">
          <RoutinePreview
            v-track:click="gtmData(routine, index)"
            v-track:view="gtmData(routine, index)"
            :routine="routine"
            :tag-facets="tagFacets"
          />
        </div>
      </div>
    </div>
    <div class="lg:hidden">
      <CardSlider :breakpoints="breakpoints" :heading="routinesLabel">
        <div v-for="(routine, index) in routines" :key="routine.id">
          <RoutinePreview
            v-track:click="gtmData(routine, index)"
            v-track:view="gtmData(routine, index)"
            :routine="routine"
            :tag-facets="tagFacets"
          />
        </div>
      </CardSlider>
      <div v-if="cta" class="flex container">
        <CtaArrow v-bind="cta" class="mt-4 ml-auto" />
      </div>
    </div>
  </div>
</template>
<script>
import RoutinePreview from '@/components/exercises/RoutinePreview';
import { exercisesFacets } from '@/utils/algolia';
import CtaArrow from '@/components/common/CtaArrow';
import CardSlider from '@/components/common/CardSlider';

export default {
  components: {
    CardSlider,
    CtaArrow,
    RoutinePreview,
  },
  props: {
    heading: {
      type: String,
      default: '',
    },
    underliner: {
      type: String,
      default: '',
    },
    linkListLabel: {
      type: String,
      default: '',
    },
    linkList: {
      type: Array,
      default: () => [],
    },
    routinesLabel: {
      type: String,
      default: '',
    },
    routines: {
      type: Array,
      default: () => [],
    },
    ctaEntry: {
      type: Array,
      default: () => null,
    },
    ctaText: {
      type: String,
      default: '',
    },
    blockPosition: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      breakpoints: [
        {
          minWindowWidth: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      ],
    };
  },
  computed: {
    // render Routine Tag-facet-buttons derived from ctaEntry-pageProfile
    tagFacets() {
      return this.ctaEntry[0] ? exercisesFacets(this.ctaEntry[0].pageProfile).slice(0, 2) : [];
    },
    cta() {
      return this.ctaEntry[0] ? { to: { path: this.$localeRootPath(this.ctaEntry[0].uri) }, text: this.ctaText } : null;
    },
  },

  methods: {
    gtmData(payload, index) {
      return {
        promotion_id: payload.uri,
        promotion_name: [this.$route?.name, payload.title].join(' / '),
        creative_name: 'largeExerciseRoutineSlider',
        creative_slot: [this.$route?.name, this.blockPosition + 1, index + 1].join(' / '),
      };
    },
  },
};
</script>

<style>
.btn-box {
  @apply px-6 py-2 rounded-md font-medium;
}
.btn-box-white {
  @apply bg-white text-blackly;
}
</style>
